// Used for the notifications, which use Quasar Notify plugin

export enum NotificationActionMessage {
  PERFORMED_WORK,
  ISSUES_RAISED,
  ALL_RAISED,
  UNSUBMITTED_WORK,
}

// Used for SfxCardNotification

export enum CardNotificationEvent {
  ASSIGNED_WORK_ORDER,
  COMMENTED_WORK_ORDER,
  COMMENTED_PERFORMED_WORK,
  REJECTED_ISSUE,
  REJECTED_WORK,
  ACCEPTED_WORK,
  CORRECTED_ISSUE,
  ADDED_ISSUE,
}
